// extracted by mini-css-extract-plugin
module.exports = {"link":"monthLink-module__link___7cP19","link__chosen":"monthLink-module__link__chosen___pYWR1"};